import { Pipe, PipeTransform, LOCALE_ID, inject } from '@angular/core';

@Pipe({ name: 'agFilter' })
// filters out an entry from an array based on input and
// returns the match.
// value - the object being compared
// valuesToSearch - the array of values that are searched for a match
// propertyName - the name of the property to use for comparing value to valuesToSearch
// returnProperty - the name of the property whose value will be returned
export class FilterPipe implements PipeTransform {
  locale: string;

  constructor() {
    const locale = inject(LOCALE_ID) ?? 'en-US';

    this.locale = locale;
  }

  transform(
    value: any,
    valuesToSearch: any[],
    propertyName: string,
    returnProperty: string,
  ): any {
    if (!value || !valuesToSearch) {
      return null;
    }

    const match = valuesToSearch.find((entry) => {
      if (!entry || !entry[propertyName]) {
        return false;
      }
      return value == entry[propertyName];
    });

    if (!match) {
      return null;
    }

    return match[returnProperty];
  }
}
